window.TeamScheduleAPI = new function () {

    var self = this;

    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.getBaseAPI("TSTeamScheduleServers") : publicConfiguration.getBaseAPI("TeamScheduleServers");
    _protected.setApiUrl(url);

    self.RESPONSE_TAGS = {
        PAYMENT_TYPE: 'payment_type',
        PENALTY_PAYMENT_TYPE: 'penalty_payment_type',
    }

    self.PAYMENT_TYPES = {
        BLENDED_RATE: 'BLENDED_RATE',
    }

    self.REVENUE_CENTERS_ORG_VISIBILITY_MODE = {
        BUSINESS: 'BUSINESS',
        BUSINESS_SERVICE: 'BUSINESS_SERVICE',
        BUSINESS_CHILDREN: 'BUSINESS_CHILDREN'
    };
    self.getSchedulesDetailsList = function (brandId, requestParams) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject("brand id is required.");
            return deferred.promise;
        }

        var params = {
            dates: moment(requestParams.week).format("MMM DD, YYYY"),
            include_submissions: requestParams.includeSubmissions,
            include_children: requestParams.includeChildren
        };

        _protected.request("brands/" + brandId + "/schedule/basic", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.schedules || []);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    /**
     * Get brand schedule's basic info for this date
     * @param brandId
     * @param date (the day of the schedule you want info for)
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getBrandScheduleInfoForDate = function (brandId, date) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject("brand id is required.");
            return deferred.promise;
        }

        var params = {};

        params['dates'] = date;

        _protected.request("brands/" + brandId + "/schedule", "GET", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data.schedule || []);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.getOffersPositionsCount = function(brandId, positionsCodes) {
        var deferred = $q.defer();

        var params = {position_codes: positionsCodes.join(',')};


        _protected.request("brands/" + brandId + "/offers/positions/count", "GET", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data.positions || []);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    /**
     * This will get a branch schedule Id if exisit or will create it
     *
     * @param brandId
     * @param day
     * @returns {deferred.promise|{then, always}}
     */
    self.createBrandSchedule = function (brandId, day) {
        var deferred = $q.defer();

        var params = {
            date: day
        };

        _protected.request("brands/" + brandId + "/schedule", "POST", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data.schedule);
                }
                else {
                    deferred.reject(res);
                }
            });

        return deferred.promise;
    };

    self.getScheduleRoles = function (scheduleId, day) {
        var deferred = $q.defer();

        var params = {};

        if (day) {
            params['day'] = day;
        }

        _protected.request("schedules/" + scheduleId + "/roles", "GET", params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateBrandSchedule = function (brandId, schedulePayload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/schedules/generate", "POST", schedulePayload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUnassignedShiftsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/unassigned_shifts", "GET")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateUnassignedShiftsSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/unassigned_shifts", "PUT", payload)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.clearPersonShifts = function (scheduleId, day, userId) {
        var deferred = $q.defer();

        if (!userId) {
            userId = "VIRTUAL";
        }

        var url = "schedules/" + scheduleId + "/users/" + userId + "/shifts";

        if (day) {
            url = url + "?day=" + day;
        }

        _protected.request(url, "DELETE")
            .then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.clearAssigneeShiftsFromRole = function (scheduleId, roleId, day, userId) {
        var deferred = $q.defer();

        if (!userId) {
            userId = "VIRTUAL";
        }

        var url = "schedules/" + scheduleId + "/roles/" + roleId + "/users/" + userId + "/shifts";

        if (day) {
            url = url + "?day=" + day;
        }

        _protected.request(url, "DELETE")
            .then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.clearAssigneeShiftsFromCategory = (brandId, scheduleId, categoryId, day, userId) => {
        return new Promise(async (resolve, reject) => {
            let params = {};
            if (day) {
                params.day = day;
            }
            userId = userId ?? "VIRTUAL";
            try {
                let response = await _protected.request(`brands/${brandId}/schedules/${scheduleId}/categories/${categoryId}/role_days/users/${userId}/shifts`, 'DELETE', params);
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                if (response?.data?.status_code === 200 && response.data.data) {
                    resolve(response.data.data);
                } else {
                    reject(response);
                }
            } catch (e) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                reject(e);
            }
        });
    };

    self.addNewRevenue = function (scheduleId, date, salesRevenue) {
        var deferred = $q.defer();

        var data = {
            date: date,
            sales_revenue: salesRevenue
        };

        _protected.request("schedules/" + scheduleId + "/sales_revenue", "PUT", data)
            .then(function (res) {
                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addRoleAssignees = (brandId, scheduleId, roleId, userIds, day) => {
        var deferred = $q.defer();

        var data = {
            ids: userIds
        };

        _protected.request(`brands/${brandId}/schedules/${scheduleId}/roles/${roleId}/assignees${(day ? ('?day=' + day) : '')}`, "POST", data)
            .then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deletePersonFromSchedule = function (scheduleId, userId, day, keepShifts) {
        var deferred = $q.defer();

        var data = {
            keep_shifts: keepShifts
        };

        if (day) {
            data['day'] = day;
        }

        _protected.request("schedules/" + scheduleId + "/users/" + userId, "DELETE", data)
            .then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteAssigneesFromRole = function (scheduleId, roleId, day, keepShifts) {
        var deferred = $q.defer();

        var data = {
            keep_shifts: keepShifts
        };

        if (day) {
            data['day'] = day;
        }

        _protected.request("schedules/" + scheduleId + "/roles/" + roleId, "DELETE", data)
            .then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteAssigneeFromCategory = (brandId, scheduleId, categoryId, userId, day, keepShifts) => {
        return new Promise(async (resolve, reject) => {
            let params = {
                keep_shifts: keepShifts,
            };
            if (day) {
                params.day = day;
            }
            try {
                let response = await _protected.request(`brands/${brandId}/schedules/${scheduleId}/categories/${categoryId}/role_days/users/${userId}`, 'DELETE', params);
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                if (response?.data?.status_code === 200 && response.data.data) {
                    resolve(response.data.data);
                } else {
                    reject(response);
                }
            } catch (e) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                reject(e);
            }
        });
    };

    self.deleteRoleAssignees = function (scheduleId, roleId, userId, day, keepShifts) {
        var deferred = $q.defer();

        var data = {
            keep_shifts: keepShifts
        };

        if (day) {
            data['day'] = day;
        }

        _protected.request("schedules/" + scheduleId + "/roles/" + roleId + "/users/" + userId, "DELETE", data)
            .then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEnterpriseWeekReport = function (brand_ids, date, filter) {
        var defer = $q.defer();

        var request = {
            date: date,
            filter: filter,
            brand_ids: brand_ids
        };

        _protected.request("brands/reports/enterprise_schedule", "GET", request)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getStartDayOfLastPublishedWeek = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/schedules?rank=LAST&level=FINANCIAL_UNIT", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createScheduleTemplate = function (brandId, templateData) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/schedule_templates", "POST", templateData)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data.schedule_templates);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getScheduleTemplatesList = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/schedule_templates", "GET")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.deleteScheduleTemplate = function (brandId, templateId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/schedule_templates/" + templateId, "DELETE")
            .then(function (res) {
                    if (res.data && res.data.status_code == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.deleteScheduleShift = function (scheduleId, assigneeId, shiftId, params) {
        var deferred = $q.defer();

        _protected.request("assignees/" + assigneeId + "/shifts/" + shiftId, "DELETE", params)
            .then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Duplicate selected schedule (if destination id is defined then add it to params and duplicate WEEKLY)
     * else it will duplicate DAILY
     *
     * @param srcScheduleId
     * @param fromDay
     * @param toDay
     * @param dstScheduleId
     * @param includeSales
     * @param overwriteDestination
     * @param positionCodes
     * @param scheduleData
     * @param unassignAssignedShifts
     * @returns {deferred.promise|{then, always}}
     */
    self.duplicateSchedule = function (brandId, srcScheduleId, fromDay, toDay, dstScheduleId, includeSales, overwriteDestination, positionCodes, scheduleData, unassignAssignedShifts, ensureNoOverlapWithAvailability) {

        var deferred = $q.defer();
        var params = {};

        params['schedule'] = {id: dstScheduleId};

        if (!srcScheduleId) {
            throw "No schedule id";
        }

        if (fromDay) {
            params['from_day'] = fromDay;
        }

        if (toDay) {
            params['to_day'] = toDay;
        }

        if (includeSales) {
            params['copy_sales_revenue'] = includeSales;
        }

        params['unassign_assigned_shifts_overlapped_with_absence'] = ensureNoOverlapWithAvailability;

        if (overwriteDestination) {
            params['overwrite_destination'] = overwriteDestination;
        }

        if (positionCodes) {
            params['position_codes'] = positionCodes;
        }

        if (scheduleData && Object.keys(scheduleData).length) {
            params['schedule']['roles'] = scheduleData['roles'];
        }

        if (unassignAssignedShifts) {
            params['unassign_assigned_shifts'] = unassignAssignedShifts;
        }

        _protected.uniqueRequest("brands/" + brandId + "/schedules/" + srcScheduleId + "/duplicate", "POST", params)
            .then(function (res) {

                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Updates an existing
     * @param scheduleId
     * @param templateId
     * @param templateName
     * @returns {deferred.promise|{then, always}}
     */
    self.updateScheduleTemplate = function (scheduleId, templateId, templateName) {
        var deferred = $q.defer();

        var payload = {
            template_id: templateId,
            template_name: templateName
        };

        _protected.request("schedules/" + scheduleId, "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Load schedule from template
     *
     * @param scheduleId
     * @param templateId
     * @returns {deferred.promise|{then, always}}
     */
    self.loadScheduleTemplate = function (scheduleId, templateId, isConfirmed) {
        var deferred = $q.defer();

        var payload = {
			is_confirmed: isConfirmed || false
        };

        _protected.request("schedules/" + scheduleId + "/load?from=" + templateId, "POST", payload)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.templates);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Publish the schedule
     *
     * @param scheduleId
     * @param payload
     * @returns {deferred.promise|{then, always}}
     */
    self.publishSchedule = function (brandId, scheduleId, payload) {

		var deferred = $q.defer();
		var scheduleVersion = TeamScheduleV2API.getScheduleVersioning(scheduleId);
        var fairSchedulingService = $injector.get("fairSchedulingService");

		if (scheduleVersion) {
            payload['version'] = scheduleVersion['unpublished_version'] || 0;

            var handleOldVersionError = function () {
                HNotifications.show({
                    title: $filter("translate")("A new version of the schedule exists, refresh the page and try again") + ".",
                    icon: "fa-info-circle",
                    type: "danger",
                    timeout: 10000
                });
                fairSchedulingService.clearCache();
                deferred.reject({ error: "OLD_VERSION" });
            };

            TeamScheduleV2API.loadScheduleVersion(scheduleVersion['brand_id'], scheduleVersion['start_date'])
                .then(function (recentScheduleVersion) {
                    if (recentScheduleVersion['unpublished_version'] === payload['version']) {
                        sendPublishRequest();
                    }
                    else {
                        handleOldVersionError();
                    }
                })
                .catch(function (err) {
                    console.error("Failed to check schedule version:", err);
                    sendPublishRequest();
                });

            var sendPublishRequest = function () {
                _protected.request("brands/" + brandId + "/schedules/" + scheduleId + "/publish", "POST", payload)
                    .then(function (res) {
                            if (res.data) {
                                fairSchedulingService.clearCache();
                                deferred.resolve(res.data.data);
                            } else {
                                deferred.reject(res);
                            }
                    })
                    .catch(function (err) {
                        console.error(err);
                        if (err.status === 412) {
                            handleOldVersionError();
                        } else if (err.status === 400 && ['ONE_OR_MORE_JOB_TITLE_TIME_GAP_FOUND', 'ONE_OR_MORE_JOB_TITLE_START_TIME_NOT_FOUND'].indexOf(err.data?.status) > -1) {
                            deferred.reject({error: err.data.status});
                        } else {
                            deferred.reject(err);
                        }
                    })
                    .finally(function () {
                        TeamScheduleV2API.updateScheduleVersion(scheduleId);
                    });
            };
        }
        else {
            deferred.reject({ error: "Can't find schedule version" });
        }

        return deferred.promise;
    };

    self.publishScheduleWithToken = (brandId, scheduleId, payload) => {
        const deferred = $q.defer();
        const scheduleVersion = TeamScheduleV2API.getScheduleVersioning(scheduleId);
        const fairSchedulingService = $injector.get("fairSchedulingService");

        if (scheduleVersion) {
            payload['version'] = scheduleVersion['unpublished_version'] || 0;

            const handleOldVersionError = () => {
                HNotifications.show({
                    title: $filter("translate")("A new version of the schedule exists, refresh the page and try again") + ".",
                    icon: "fa-info-circle",
                    type: "danger",
                    timeout: 10000
                });
                fairSchedulingService.clearCache();
                deferred.reject({ error: "OLD_VERSION" });
            };

            TeamScheduleV2API.loadScheduleVersion(scheduleVersion['brand_id'], scheduleVersion['start_date'])
                .then((recentScheduleVersion) => {
                    if (recentScheduleVersion['unpublished_version'] === payload['version']) {
                        sendPublishRequest();
                    }
                    else {
                        handleOldVersionError();
                    }
                })
                .catch((err) => {
                    console.error("Failed to check schedule version:", err);
                    sendPublishRequest();
                });

            const sendPublishRequest = async () => {
                const v2Url = self.apiUrl.replace("v1", "v2");
                let generatedToken;
                try {
                    generatedToken = await TeamLiveShiftOfferFinancialsApi.generatePublishToken(brandId, scheduleId, payload);
                } catch(error) {
                    deferred.reject({error: error, code: "TOKEN_GENERATION_FAILED"});
                    return;
                }
                payload = {...payload, token: generatedToken.token};
                _protected.request(`${v2Url}brands/${brandId}/schedules/${scheduleId}/publish`, "POST", payload)
                    .then((res) => {
                        if (res.data) {
                            fairSchedulingService.clearCache();
                            deferred.resolve(res.data.data);
                        } else {
                            deferred.reject(res);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        if (err.status === 412) {
                            handleOldVersionError();
                        } else if (err.status === 400 && ['ONE_OR_MORE_JOB_TITLE_TIME_GAP_FOUND', 'ONE_OR_MORE_JOB_TITLE_START_TIME_NOT_FOUND'].indexOf(err.data?.status) > -1) {
                            deferred.reject({error: err.data.status});
                        } else {
                            deferred.reject(err);
                        }
                    })
                    .finally(() => {
                        TeamScheduleV2API.updateScheduleVersion(scheduleId);
                    });
            };
        }
        else {
            deferred.reject({ error: "Can't find schedule version" });
        }

        return deferred.promise;
    };

    self.withdrawSchedule = function (brandId, scheduleId, submissionId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/schedules/" + scheduleId + "/submissions/" + submissionId + "/withdraw", "POST")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            },function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.rejectSchedule = function (brandId, scheduleId, submissionId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/schedules/" + scheduleId + "/submissions/" + submissionId + "/reject", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            },function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.approveSchedule = function (brandId, scheduleId, submissionId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/schedules/" + scheduleId + "/submissions/" + submissionId + "/approve", "POST", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            },function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.submitScheduleApproval = function (brandId, scheduleId, payload) {
        var deferred = $q.defer();
        var scheduleVersion = TeamScheduleV2API.getScheduleVersioning(scheduleId);
        var fairSchedulingService = $injector.get("fairSchedulingService");

        if (scheduleVersion) {
            payload['version'] = scheduleVersion['unpublished_version'] || 0;

            TeamScheduleV2API.loadScheduleVersion(scheduleVersion['brand_id'], scheduleVersion['start_date'])
                .then(function (recentScheduleVersion) {
                    if (recentScheduleVersion['unpublished_version'] === payload['version']) {
                        sendPublishRequest();
                    }
                    else {
                        HNotifications.show({
                            title: $filter("translate")("A new version of the schedule exists, refresh the page and try again") + ".",
                            icon: "fa-info-circle",
                            type: "danger",
                            timeout: 10000
                        });
                        fairSchedulingService.clearCache();
                        deferred.reject({ error: "OLD_VERSION" });
                    }
                })
                .catch(function (err) {
                    console.error("Failed to check schedule version:", err);
                    sendPublishRequest();
                });

            var sendPublishRequest = function () {
                _protected.request("brands/" + brandId + "/schedules/" + scheduleId + "/submissions", "POST", payload)
                    .then(function (res) {
                            if (res.data && res.data.data && res.data.status_code == 200) {
                                fairSchedulingService.clearCache();
                                deferred.resolve(res.data.data);
                            }
                            else {
                                deferred.reject(res);
                            }
                    })
                    .catch(function (err) {
                        console.error(err);
                        deferred.reject(err);
                    })
                    .finally(function () {
                        TeamScheduleV2API.updateScheduleVersion(scheduleId);
                    });
            };
        }
        else {
            deferred.reject({ error: "Can't find schedule version" });
        }

        return deferred.promise;
    };

    self.submitScheduleApprovalWithToken = (brandId, scheduleId, payload) => {
        const deferred = $q.defer();
        const scheduleVersion = TeamScheduleV2API.getScheduleVersioning(scheduleId);
        const fairSchedulingService = $injector.get("fairSchedulingService");

        if (scheduleVersion) {
            payload['version'] = scheduleVersion['unpublished_version'] || 0;

            TeamScheduleV2API.loadScheduleVersion(scheduleVersion['brand_id'], scheduleVersion['start_date'])
                .then((recentScheduleVersion) => {
                    if (recentScheduleVersion['unpublished_version'] === payload['version']) {
                        sendPublishRequest();
                    }
                    else {
                        HNotifications.show({
                            title: $filter("translate")("A new version of the schedule exists, refresh the page and try again") + ".",
                            icon: "fa-info-circle",
                            type: "danger",
                            timeout: 10000
                        });
                        fairSchedulingService.clearCache();
                        deferred.reject({ error: "OLD_VERSION" });
                    }
                })
                .catch((err) => {
                    console.error("Failed to check schedule version:", err);
                    sendPublishRequest();
                });

            const sendPublishRequest = async () => {
                const v2Url = self.apiUrl.replace('v1', 'v2');
                let generatedToken;
                try {
                    generatedToken = await TeamLiveShiftOfferFinancialsApi.generatePublishToken(brandId, scheduleId, payload);
                } catch(error) {
                    deferred.reject({error: error, code: "TOKEN_GENERATION_FAILED"});
                    return;
                }
                payload = {...payload, token: generatedToken.token};
                _protected.request(`${v2Url}brands/${brandId}/schedules/${scheduleId}/submissions`, "POST", payload)
                    .then((res) => {
                        if (res.data && res.data.data && res.data.status_code == 200) {
                            fairSchedulingService.clearCache();
                            deferred.resolve(res.data.data);
                        }
                        else {
                            deferred.reject(res);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        deferred.reject(err);
                    })
                    .finally(() => {
                        TeamScheduleV2API.updateScheduleVersion(scheduleId);
                    });
            };
        }
        else {
            deferred.reject({ error: "Can't find schedule version" });
        }

        return deferred.promise;
    };

    /**
     * Loads the positions by category
     * @returns {*}
     */
    self.loadPositions = function () {
        var deferred = $q.defer();

        _protected.request('category_positions', {
            method: 'GET',
            headers: swCacheService.getCacheHeader('stale-while-revalidate', 'disk')
        }).then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.loadBrandPositions = function (brandId, scheduleId) {
        var deferred = $q.defer();

        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        _protected.request('brands/' + brandId + '/schedules/' + scheduleId + '/roles', 'GET').then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    self.saveBrandRoles = function (scheduleId, positions, addAssignees) {
        var deferred = $q.defer();

        var data = {
            roles: positions
        };

        data['add_assignees'] = addAssignees;

        _protected.request('schedules/' + scheduleId + "/roles", 'POST', data).then(function (res) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);

                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                TeamScheduleV2API.updateScheduleVersion(scheduleId);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getShiftsSources = function (brandId, scheduleId, payLoad) {
        var deferred = $q.defer();
        var params = {
            sources: payLoad.sources.join(',')
        }

        _protected.request('brands/' + brandId + '/schedules/' + scheduleId + '/shifts/sources', 'GET', params)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data['assignee_shift_sources'] || []);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    }

    /**
     * Get Brand Shift Offers
     *
     * @param brandId
     * @param userId
     * @returns {deferred.promise|{then, always}}
     */
    self.getBrandShiftOffers = function (brandId, offset, limit, userId) {

        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        var deferred = $q.defer();

        offset = offset || 0;
        limit = limit || 10;

        var params = {
            status: "PENDING_APPROVAL",
            offset: offset,
            limit: limit
        };

        if (userId) {
            params.user_id = userId;
        }

        _protected.request('brands/' + brandId + '/offers', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    // withdraw shift trade request

    self.deleteOfferRequest = function (offerId) {
        var deferred = $q.defer();

        _protected.request('employees/offers/' + offerId, 'DELETE')
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * Get brand shift offers activities
     *
     * @param brandId
     * @param page
     * @param limit
     * @param employeeId
     * @returns {deferred.promise|{then, always}}
     */
    self.getBrandShiftActivities = function (brandId, offset, limit, employeeId) {

        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        var deferred = $q.defer();

        offset = offset || 0;
        limit = limit || 10;

        var params = {
            offset: offset,
            limit: limit,
            status: "APPROVED,REJECTED",
        };

        if (employeeId) {
            params.user_id = employeeId;
        }

        _protected.request('brands/' + brandId + '/offers', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };


    /**
     * Get users of active offers
     *
     * @param brandId
     * @returns {deferred.promise|{then, always}}
     */
    self.getActiveOffersUsers = function (brandId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/offers/users', 'GET')
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Update the employee offer request - employee side
     *
     * @param offerId
     * @param status
     * @returns {deferred.promise|{then, always}}
     */
    self.updateEmployeeOfferRequest = function (offerId, status, portions) {

        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        var deferred = $q.defer();

        var payload = {
            status: status
        };

        if (portions.length) {
            payload['portions'] = portions;
        }

        _protected.uniqueRequest('employees/offers/' + offerId, 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    /**
     * Update offer request - employer side
     *
     * @param brandId
     * @param offerId
     * @param status
     * @returns {deferred.promise|{then, always}}
     */
    self.updateBrandOfferRequest = function (brandId, offerId, status) {

        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        var deferred = $q.defer();

        var payload = {
            status: status
        };

        _protected.uniqueRequest('brands/' + brandId + '/offers/' + offerId, 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    self.rejectBrandOfferRequest = function (brandId, offerId) {

        var deferred = $q.defer();

        _protected.uniqueRequest('brands/' + brandId + '/offers/' + offerId + '/requests/reject', 'POST')
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    /**
     * Request a time off for the logged in employee
     * @param data
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.requestTimeOff = function (data) {
        var deferred = $q.defer();

        _protected.request('employees/timeoffs', 'POST', data)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get employee's time off requests
     * @param brandId
     * @param offset
     * @param limit
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getEmployeeTimeOffs = function (brandId, offset, limit) {

        var deferred = $q.defer();

        var params = {
            brand_id: brandId,
            status: "PENDING_APPROVAL",
            offset: offset,
            limit: limit
        };

        _protected.request('employees/timeoffs', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* get employee time off settings for new request */
    self.getEmployeeTimeOffRequestSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request('employees/brands/' + brandId + '/settings/timeoff', 'GET')
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };


    /**
     * Gets the employee time off activities
     * @param brandId
     * @param offset
     * @param limit
     * @param orderBy
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getEmployeeTimeOffActivities = function (brandId, offset, limit, orderBy) {

        var deferred = $q.defer();

        offset = offset || 0;
        limit = limit || 10;

        var params = {
            brand_id: brandId,
            order_by: orderBy,
            offset: offset,
            limit: limit,
            status: "APPROVED,REJECTED,WITHDRAWN,DELETED"
        };

        _protected.request('employees/timeoffs', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Save Time off requests by the employer for the passed user id
     * @param brandId
     * @param payload
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.saveEmployerTimeOffsForEmployee = function (brandId, payload) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/timeoffs', 'POST', payload)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * Uodated the status of the time off request either by accept or reject
     * @param brandId
     * @param timeOffId
     * @param status
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.updateTimeOffRequest = function (brandId, timeOffId, status) {
        var deferred = $q.defer();

        var payload = {
            status: status
        };

        _protected.request('brands/' + brandId + '/timeoffs/' + timeOffId, 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Update the status of the time off request from employee side to DELETED
     * @param timeOffId
     * @param status
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.deleteEmployeeTimeOffRequest = function (timeOffId) {
        var deferred = $q.defer();

        _protected.request('employees/timeoffs/' + timeOffId, 'DELETE')
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * Gets brand time off history
     * @param brandId
     * @param status
     * @param offset
     * @param limit
     * @param employeeId
     * @param orderBy
     * @param categoryCode
     * @param positionCode
     * @param startingDate
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getBrandTimeOffs = function (brandId, status, offset, limit, employeeId, orderBy, categoryCode, positionCode, startingDate) {

        var deferred = $q.defer();

        offset = offset || 0;
        limit = limit || 10;

        var params = {
            status: status,
            offset: offset,
            limit: limit,
            user_id: employeeId,
            order_by: orderBy,
            category: categoryCode,
            position: positionCode,
            starting_date: startingDate
        };

        _protected.request('brands/' + brandId + '/timeoffs', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Gets the active users who have time off requests or have time off activity
     * @param brandId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getActiveTimeOffsUsers = function (brandId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/timeoffs/users', 'GET')
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    const [getTeamliveBusinessSettings, resetTeamliveBusinessSettings] = cacheService.cache((brandId, params) => {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/schedule/business/settings`, 'GET', params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data.settings);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    });

    self.getTeamliveBusinessSettings = getTeamliveBusinessSettings;

    self.getBusinessScheduleSettings = function (brandId, includeBrands) {

        var deferred = $q.defer();

        let params = {
            include_brands: includeBrands
        };

        _protected.request(`brands/${brandId}/business/settings/schedule`, 'GET', params)
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBusinessRevenueCenterSettings = async (brandId) => {
        try {
            const res = await _protected.request(`brands/${brandId}/business/settings/revenue_centers`, 'GET');
            if (res?.data?.status_code === 200) {
                return res.data.data;
            }
        } catch (err) {
            console.error(err);
        }
    };

    self.getRevenueCenterSettings = async (brandId) => {
        try {
            const res = await _protected.request(`brands/${brandId}/settings/revenue_centers`, 'GET');
            if (res?.data?.status_code === 200) {
                return res.data.data;
            }
        } catch (err) {
            console.error(err);
        }
    };

    self.updateRevenueCenterSettings = async (brandId, payLoad) => {
        try {
            const response = await _protected.request(`brands/${brandId}/settings/revenue_centers`, "PUT", payLoad);
            if (response?.status === 200) {
                return response.data.data;
            }
        } catch (err) {
            console.error(err);
        }
    };

    self.updateBusinessRevenueCenterSettings = async (brandId, payLoad) => {
        try {
            const response = await _protected.request(`brands/${brandId}/business/settings/revenue_centers`, "PUT", payLoad);
            if (response?.status === 200) {
                return response.data.data;
            }
        } catch (err) {
            console.error(err);
        }
    };

    self.saveBusinessScheduleSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/business/settings/schedule', 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
                resetTeamliveBusinessSettings();
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBusinessScheduleApprovalFlowSettings = async (brandId, includeBrands) => {
        let params = {
            include_brands: includeBrands
        };

        let response = await _protected.request(`brands/${brandId}/business/settings/schedule_approval_flow`, 'GET', params);
        if (response?.data?.status_code === 200) {
            return response.data.data;
        }
        throw response;
    };

    self.saveBusinessScheduleApprovalFlowSettings = async (brandId, payload) => {
        let response = await _protected.request(`brands/${brandId}/business/settings/schedule_approval_flow`, 'PUT', payload);
        if (response.data.status_code !== 200) {
            throw response;
        }
        return response.data.data;
    };

    self.getBrandSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBrandSettings = function (brandId, settings) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings', 'PUT', settings)
            .then(function (res) {
                if (res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getScheduleWarningsSettings = function (brandId) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/settings/schedule_warnings`, 'GET')
            .then((response) => {
                if (response?.data?.status_code === 200) {
                    deferred.resolve(response.data.data);
                } else {
                    deferred.reject(response);
                }
            }).catch((error) => {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.updateBrandScheduleWarningsSetting = function (brandId, payload) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/settings/schedule_warnings`, 'PUT', payload)
            .then((response) => {
                if (response?.data?.status_code === 200) {
                    deferred.resolve(response.data);
                } else {
                    deferred.reject(response);
                }
            }).catch((error) => {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    self.getScheduleDayNotes = function (brandId, scheduleId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/schedules/' + scheduleId + '/schedule_day_notes', 'GET')
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    }

    self.addScheduleDayNotes = function (brandId, scheduleId, date, note) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/schedules/' + scheduleId + '/schedule_day_notes', 'POST', {
            date: date,
            note: note,
        })
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    }

    self.updateScheduleDayNotes = function (brandId, scheduleId, noteId, note) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/schedules/' + scheduleId + '/schedule_day_notes/' + noteId, 'PUT', {
            note: note,
        })
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    }

    self.deleteScheduleDayNotes = function (brandId, scheduleId, noteId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/schedules/' + scheduleId + '/schedule_day_notes/' + noteId, 'DELETE')
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    }

	/**
	 * Get all pending timeoff requests count for all brand's users OR for specific user of a brand with status
	 * @param brandId
	 * @param userId
	 * @param status
	 * @returns {deferred.promise|{then, always}|{then}}
	 */
	self.getBrandPendingTimeoffRequestsCount = function (brandId, status, userId) {

		var deferred = $q.defer();

		var params = {
			status: status
		};

		if (userId) {
			params["user_id"] = userId;
		}

		_protected.request("brands/" + brandId + "/timeoffs/count", "GET", params)
				.then(function (res) {
					if (res.data && res.data.data && res.data.status_code == 200) {
						var counts = {};
						for (var i in res.data.data.counts) {
							if (res.data.data.counts[i].status == "PENDING_APPROVAL") {
								counts.timeoffsRequestCount = res.data.data.counts[i].request_count;
							}
						}
						deferred.resolve(counts);
					}
					else {
						deferred.reject(res);
					}
				},function(error){
					deferred.reject(error);
				});

		return deferred.promise;
	};

	/**
	 * Get all pending shift requests count for all brand's users
	 * @param brandId
	 * @returns {deferred.promise|{then, always}|{then}}
	 */
	self.getBrandPendingShiftOfferRequestsCount = function (brandId) {

		var deferred = $q.defer();

		var params = {
			status: ["PENDING_APPROVAL"]
		};

		_protected.request("brands/" + brandId + "/offers/count", "GET", params)
				.then(function (res) {
					if (res.data && res.data.data && res.data.status_code == 200) {
						var counts = {};
						for (var i in res.data.data.counts) {
							if (res.data.data.counts[i].status == "PENDING_APPROVAL") {
								counts.shiftOfferRequestCount = res.data.data.counts[i].request_count;
							}
						}
						deferred.resolve(counts);
					}
					else {
						deferred.reject(res);
					}
				},function(error){
					deferred.reject(error);
				});

		return deferred.promise;
	};

	/**
	 * Mark loaded timeoff activities as seen
	 *
	 * @param shiftIds
	 * @returns {deferred.promise|{then}|{then, always}}
	 */
	self.markTimeoffsAsSeen = function (shiftIds) {

		var deferred = $q.defer();

		var params = {
			ids: shiftIds
		};

		_protected.request("timeoffs/activities/markSeen", "POST", params)
				.then(function (res) {
					if (res.data && res.data.data && res.data.status_code == 200) {
						deferred.resolve(res.data.data);
					}
					else {
						deferred.reject(res);
					}
				}, function (error) {
					deferred.reject(error);
				});

		return deferred.promise;
	};

    /**
     * Get all brand's notifications' counts
     * @param brandId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getBrandShiftOfferCount = function (brandId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/notifications/counts", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    var counts = {
                        offer: {}
                    };
                    for (var i in res.data.data.counts) {
                        if (res.data.data.counts[i].type == "OFFER") {
                            counts.offer.activityCount = res.data.data.counts[i].activity_count;
                            counts.offer.requestCount = res.data.data.counts[i].request_count;
                        }
                    }
                    deferred.resolve(counts);
                }
                else {
                    deferred.reject(res);
                }
            },function(error){
                deferred.reject(error);
            });

        return deferred.promise;
    };

	/**
	 * Gets availability count for the employee
	 *
	 * @param brandId
	 * @returns {deferred.promise|{then, always}|{then}}
	 */
	self.getEmployeeAvailabilityCount = function (brandId) {
		var deferred = $q.defer();

		var params = {
			brand_id: brandId,
			status: ["APPROVED", "REJECTED", "PENDING_APPROVAL"]
		};

		_protected.request("employees/availabilities/count", "GET", params).then(function (res) {
					if (res.data && res.data.data && res.data.status_code == 200) {
						var counts = {
							requestCount: 0,
							activityCount: 0
						};
						for (var i in res.data.data.counts) {
							if (res.data.data.counts[i].status == "PENDING_APPROVAL") {
								counts.requestCount += res.data.data.counts[i].request_count;
							}
							else if (res.data.data.counts[i].status == "APPROVED" || res.data.data.counts[i].status == "REJECTED") {
								counts.activityCount += res.data.data.counts[i].activity_count;
							}
						}
						deferred.resolve(counts);
					}
					else {
						deferred.reject(res);
					}
				},
				function (err) {
					deferred.reject(err);
				});

		return deferred.promise;
	};

	/**
	 * Gets availability count for the brand
	 *
	 * @param brandId
	 * @param userId
	 * @returns {deferred.promise|{then, always}|{then}}
	 */
	self.getBrandAvailabilityCount = function (brandId, userId) {
		var deferred = $q.defer();

		var params = {
			brand_id: brandId,
			status: ["PENDING_APPROVAL"]
		};

		if (userId) {
			params["user_id"] = userId;
		}

		_protected.request("brands/" + brandId + "/availabilities/count", "GET", params).then(function (res) {
					if (res.data && res.data.data && res.data.status_code == 200) {
						var counts = {
							requestCount: 0
						};
						for (var i in res.data.data.counts) {
							if (res.data.data.counts[i].status == "PENDING_APPROVAL") {
								counts.requestCount += res.data.data.counts[i].request_count;
							}
						}
						deferred.resolve(counts);
					}
					else {
						deferred.reject(res);
					}
				},
				function (err) {
					deferred.reject(err);
				});

		return deferred.promise;
	};

	self.removeUnassignedEmployees = function (scheduleId, assignees) {

		var deferred = $q.defer();

		var params = {
			ids: assignees
		};

		_protected.request("schedules/" + scheduleId + "/roles/assignees", "DELETE", params)
				.then(function (res) {
                    TeamScheduleV2API.updateScheduleVersion(scheduleId);

					if (res.data && res.data.data && res.data.status_code == 200) {
						deferred.resolve(res.data.data);
					}
					else {
						deferred.reject(res);
					}
				}, function (err) {
                    TeamScheduleV2API.updateScheduleVersion(scheduleId);
					deferred.reject(err);
				});

		return deferred.promise;
	};

    /* Get brand schedule settings */
    self.getBrandScheduleSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/schedule", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* Get brand time off settings */
    self.getBrandTimeOffSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/timeoff", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* Get brand time off settings for a new request */
    self.getBrandTimeOffRequestSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/timeoffs/settings", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* Get brand schedule settings */
    const [getScheduleSettings] = cacheService.cache(function (brandId) {
        var deferred = $q.defer();

        _protected.request(`brands/${brandId}/schedules/settings`, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    });

    self.getScheduleSettings = getScheduleSettings;

    self.getScheduleSettingsV2 = async (brandId, startDate, endDate) => {
        const params = new URLSearchParams();
        if (startDate) {
            params.append('start_date', startDate);
        }
        if (endDate) {
            params.append('end_date', endDate);
        }

        const v2Url = url.replace('v1', 'v2');
        const response = await _protected.request(`${v2Url}brands/${brandId}/schedules/settings?${params.toString()}`, "GET");

        if (response?.data?.data && response?.data?.status_code === 200) {
            return response.data.data;
        }

        throw response;
    }

    self.getEmployeeScheduleSettings = function (brandId) {

        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/schedules/settings", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    self.getEmployeeShiftConsentsCount = async (brandId, params) => {
        let response = await  _protected.request(`employees/brands/${brandId}/shifts/consents/count`, "GET", params);
        if (response.data.status_code !== 200) {
            throw (response);
        }
        return response.data.data;
    }

    self.getEmployeeShiftConsents = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/shifts/consents", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.consents);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandScheduledShiftsConsents = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + "brands/" + brandId + "/shifts/consents", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.consents);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateEmployeeShiftConsents = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/shifts/consents", "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.updateShiftConsents = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/shifts/consents", "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.notifyScheduleSubscribers = function (brandId, week) {
        var deferred = $q.defer();

        var payLoad = {
            week: week.format("YYYY-MM-DD")
        };

        _protected.request("brands/" + brandId + "/schedules/submissions/subscribers/notify", "POST", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeShiftConsentDetails = function (brandId, consentId) {
        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/shifts/consents/" + consentId, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.consent);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getShiftConsentDetailsByEmployer = function (brandId, userId, consentId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/shifts/consents/" + consentId, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.consent);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.checkPendingEmployeeConsentsCount = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/shifts/consents/check?status=PENDING_EMPLOYEE_APPROVAL", "POST")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.count);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get Multi Brands Schedule Settings.
     *
     * @returns {*}
     * @param brandIds
     */
    self.getMultiBrandsScheduleSettings = function (brandIds) {
        var deferred = $q.defer();

        _protected.request("brands/schedules/settings?brand_ids=" + brandIds, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* Get brand schedule settings */
    self.getBrandShiftOfferSettings = function (brandId) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/shift_offer", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* Update settings for brand schedule lock option, including admins allowed to unlock */
    self.updateBrandScheduleLockSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/schedule/lock", "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                    self.resetBrandScheduleLockSettings();
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* Get settings for brand schedule lock option, including admins allowed to unlock */
    [self.getBrandScheduleLockSettings, self.resetBrandScheduleLockSettings] = cacheService.cache((brandId) => {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/settings/schedule/lock`, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    });

    /* update brand schedule settings */
    self.updateBrandScheduleSettings = function (brandId, payload) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/schedule", "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* update brand schedule settings */
    self.updateBrandShiftOfferSettings = function (brandId, payload) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/shift_offer", "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* update brand time off settings */
    self.updateBrandTimeOffSettings = function (brandId, payload) {

        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/timeoff", "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get brand shift templates settings
     * @param brandId
     */
    self.getBrandShiftTemplatesSettings = function (brandId) {
        var deferred = $q.defer();
        var params = {};
        params['status'] = 'ACTIVE,ARCHIVED';

        _protected.request('brands/' + brandId + '/settings/shifts/templates', 'GET', params)
            .then(function (res) {

                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandShiftTemplates = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/shifts/templates', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getScheduleSubmissionsNotifyAdminsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request(`brands/${brandId}/submissions/settings`, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateScheduleSubmissionsNotifyAdminsSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/submissions/notifications', "PUT", payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * create brand shift template for schedule view
     * @param brandId and shiftTemplate - single shift template object
     */
    self.createBrandShiftTemplateForSchedule = async (brandId, shiftTemplate) => {
        try {
            const res = await _protected.request(`brands/${brandId}/shifts/templates`, "POST", shiftTemplate);
            
            if (res?.data?.data && res?.data?.status_code === 200) {
                return res.data.data;
            }
            else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    /**
     * create brand shift template
     * @param brandId and shiftTemplate - shift template object
     */
    self.createBrandShiftTemplate = async (brandId, shiftTemplate) => {
        try {
            const res = await _protected.request(`brands/${brandId}/settings/shifts/templates`, "POST", shiftTemplate);
            
            if (res?.data?.data && res?.data?.status_code === 200) {
                return res.data.data;
            }
            else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    /**
     * update brand shift template
     * @param brandId, shiftTemplateId and shiftTemplate - shift template object
     */
    self.updateBrandShiftTemplate = async (brandId, shiftTemplateId, shiftTemplate) => {
        try {
            const res = await _protected.request(`brands/${brandId}/settings/shifts/templates/${shiftTemplateId}`, "PUT", shiftTemplate);
            
            if (res?.data?.data && res?.data?.status_code === 200) {
                return res.data.data;
            }
            else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    /**
     * delete brand shift template
     * @param brandId and shiftTemplateId
     */
    self.deleteBrandShiftTemplate = async (brandId, shiftTemplateId) => {
        try {
            const res = await _protected.request(`brands/${brandId}/settings/shifts/templates/${shiftTemplateId}`, "DELETE");
            
            if (res?.data?.data && res?.data?.status_code === 200) {
                return res.data.data;
            }
            else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    self.updateScheduleNotes = function (scheduleId, roleId, roleDayId, note) {
        var deferred = $q.defer();

        _protected.request("schedules/" + scheduleId + "/roles/" + roleId + "/role_days/" + roleDayId + "/note", "PUT", {
            note: note
        }).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            }
            else {
                deferred.reject(res);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getPublishRestrictionsSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/publish_restrictions', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data['publish_restriction_settings']);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updatePublishRestrictionsSettings = function (brandId, publishRestrictionsSettings) {
        var deferred = $q.defer();

        var payload = {
            publish_restriction_settings: publishRestrictionsSettings
        };

        _protected.request('brands/' + brandId + '/settings/publish_restrictions', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPositionPreferences = function(brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/settings/position_preferences', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data['position_preferences']);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandPositionPreferences = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/settings/position_preferences', 'PUT', payload)
            .then(function (res) {

                if (res && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    [self.getBrandUserPreferences, self.resetBrandUserPreferences] = cacheService.cache((brandId) => {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/users/schedules/settings`, 'GET')
            .then((res) => {
                if (res?.data?.data && res.data?.status_code === 200) {
                    deferred.resolve(res.data.data.settings || {});
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    });

    self.getScheduleShiftsCount = function (brandId, scheduleId, params) {
        var deferred = $q.defer();

        _protected.request('brands/'+ brandId + '/schedules/' + scheduleId + '/shifts/count', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeClockCrossConsentDetails = function (brandId, shiftId, params) {
        var deferred = $q.defer();

        if (!brandId || !shiftId) {
            throw 'brandId and shiftId are required'
        }

        _protected.request('brands/' + brandId + '/shifts/' + shiftId + '/cross_consents', 'GET', params)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data && res.data.data.consents) {
                    deferred.resolve(res.data.data.consents);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getEmployeeClockConsentDetails = function (brandId, shiftId, params) {
        var deferred = $q.defer();

        if (!brandId || !shiftId) {
            throw 'brandId and shiftId are required'
        }

        _protected.request('brands/' + brandId + '/shifts/' + shiftId + '/consents', 'GET', params)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data && res.data.data.consents) {
                    deferred.resolve(res.data.data.consents);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getScheduleMarkedDays = function (brandId, scheduleId, params) {
        var deferred = $q.defer();

        _protected.request('brands/'+ brandId + '/schedules/' + scheduleId + '/users/schedule_user_day_markers', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addUserMarkedDay = function (brandId, scheduleId, userId,params) {
        var deferred = $q.defer();

        _protected.request('brands/'+ brandId + '/schedules/' + scheduleId + '/users/'+ userId +'/schedule_user_day_markers', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.removeUserMarkedDay = function (brandId, scheduleId, userId, markedDayId) {
        var deferred = $q.defer();

        _protected.request('brands/'+ brandId + '/schedules/' + scheduleId + '/users/'+ userId +'/schedule_user_day_markers/'+ markedDayId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLatenessReasonsSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'brandId is required';
        }

        _protected.request('brands/' + brandId + '/settings/lateness_reason', 'GET')
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data && res.data.data.lateness_reason_settings) {
                    deferred.resolve(res.data.data.lateness_reason_settings);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.updateEmployeeLatenessReasons = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'brandId is required';
        }

        _protected.request('brands/' + brandId + '/settings/lateness_reason', 'PUT', payload)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    [self.getLatenessReasons, self.resetLatenessReasons] = cacheService.cache((brandId) => {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'brandId is required';
        }

        _protected.request('brands/' + brandId + '/lateness_reasons', 'GET')
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data && res.data.data.lateness_reasons) {
                    deferred.resolve(res.data.data.lateness_reasons);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    });

    self.getEmployeeLatenessReasons = function (brandId) {
        var v2Url = url.replace('v1', 'v2');
        _protected.setApiUrl(v2Url);

        var deferred = $q.defer();

        if (!brandId) {
            throw 'brandId is required'
        }

        _protected.request('employees/brands/' + brandId + '/lateness_reasons', 'GET')
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data && res.data.data) {
                    deferred.resolve(res.data.data.lateness_reasons);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        _protected.setApiUrl(url);

        return deferred.promise;
    };

    self.updateEmployeeShiftLatenessReason = function (brandId, scheduleId, shiftId, params) {
        var deferred = $q.defer();

        if (!brandId || !scheduleId || !shiftId) {
            throw 'brandId, scheduleId and shiftId are required';
        }

        _protected.request('employees/brands/' + brandId + '/schedules/' + scheduleId + '/shifts/' + shiftId, 'PUT', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getDayOfRest = function (brandId) {

        if (!brandId) {
            throw 'brandId is required';
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/max_scheduled_days', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.max_scheduled_days);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    self.updateDayOfRest = function (brandId, maxScheduledDays) {

        if (!brandId) {
            throw 'brandId is required';
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/max_scheduled_days', 'PUT', maxScheduledDays)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    self.getShiftTradeNotificationSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/reminders', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateShiftTradeNotificationSettings = function (brandId, reminders) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/reminders', 'PUT', reminders).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandSalariedSettings = async (brandId) => {
        let response = await _protected.request(`brands/${brandId}/settings/salaried`, 'GET');
        if (response.data.status_code !== 200) {
            throw (response.error);
        }
        return response.data.data;
    };

    self.updateBrandSalariedSettings = async (brandId, payload) => {
        let response = await _protected.request(`brands/${brandId}/settings/salaried`, 'PUT', payload);
        if (response.data.status_code !== 200) {
            throw (response.error);
        }
        return response.data.data;
    };

};
